import script from "./ObjectiveTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectiveTree.vue?vue&type=script&setup=true&lang=js"

import "./ObjectiveTree.vue?vue&type=style&index=0&id=8aec1c4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aec1c4e"]])

export default __exports__